import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';



const headCells = [


 
  
  { id: 'bm_name', numeric: false, label: 'Name' },
  { id: 'bm_address', numeric: false, label: 'Address' },
  { id: 'bm_contactno', numeric: false, label: 'Phone No.' },
   { id: 'bm_gstin', numeric: false, label: 'GSTIN' },
   { id: '',  label: '' },
  ]
  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class Branch extends Component {
	
    constructor(props) {
    super(props);
   
      this.state = {redirect: false,
      Branchdata:[],bmid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
	 
	  order:'desc' ,orderBy:'',names:'',searchcustomer:'',
	          
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   
	}
	
	updateDonenewParent = (text) => {this.componentDidMount();  }
	
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,Branchdata:[]
    });
	

}
	



	componentDidMount() {
		document.title = "AthaYog Living - Branches";
	
	if(localStorage.getItem("AYLuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Default'
          })
		  }
	
	
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
  
} 




handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 

myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
}

apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxbranch.php?action=getall&bm_name='+this.state.names+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		let copy=[50, 100, 150, 200, 250];
			this.setState({  
			  Branchdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),rowsPaging:copy
			   

		    });
	  
	 
	 
     }
	 else{
		   this.setState({Branchdata:[],totaldata:0});
	 }
 
    });
}





handleChangePage = (event, newPage) => {  

 
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  }; 
  
  handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};


      branchDelete(bmid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r === true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('bm_id',bmid)
	 	   
	formData.append('userid',localStorage.getItem("AYLuserid"))
	
	
	 axios.post(Serverurl+"ajaxbranch.php", formData, {
        }).then(res => {
    
              this.setState({  
      prevpage: -1,
    
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); });
  
    
            });
 }
      }
      Branchaddbox(val){
        this.setState({ bmid: val });  
  
         setTimeout(() => this.refs.AddBranchbox.handleClickOpen(),500);

      }

render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
   

<div className="boxheading">				  
<h2> Manage Branches</h2>
</div>
<div className="clear"></div>
   <div className="searchmaster">


  
  <ul>
  
 <li>
 <p>Name</p>
 <p ><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.names}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="Name"
            name="names" onChange={this.myChangeHandler} className="txtbox"
		
          /></p></li>
		
			
	
	
		
		<li><p>
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>&nbsp;
	  <Button variant="contained" onClick={()=>{this.Branchaddbox(0)}} className="frmSecondarybtn" endIcon={<AddIcon />}>
        New
      </Button></p>
		</li> 
		
		
		
		
		</ul>
		
</div>		



<AddBranchbox ref="AddBranchbox" id={this.state.bmid}  updateDonenew={this.updateDonenewParent}/>
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Branchdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Branchdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.bm_name}</TableCell>
<TableCell>{item.bm_address}</TableCell>
<TableCell>{item.bm_contactno}</TableCell>
<TableCell>{item.bm_gstin}</TableCell>
<TableCell align="left">
<div className="actionbtns">
<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.Branchaddbox(item.bm_id)}} endIcon={<EditIcon />}>
Edit
</Button>&nbsp;&nbsp;

{item.delcnt==="0" && (
<Button variant="contained" className="frmthirdbtn" onClick={()=>{this.branchDelete(item.bm_id)}} endIcon={<DeleteIcon />}>
  Delete
</Button>
)}
 


 </div>
 
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[10,50, 100, 150, 200, 250]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onChangePage={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />   
  </Paper>
    

 </React.Fragment> 

 
 
  );
}
}


export  class  AddBranchbox extends Component {

   constructor(props) {
      super(props)
	  
      this.state = {
		  
		   open:false,name:'',bm_id:0,contactnumber:'',address:'',gstin:'',
      errormessage:'',erropen:false,btndisabled:false,
submitbtn:"Save"
	  }
      
  }
  
  
  

  
 Branchgetdata() {
	
  if(this.props.id!==0)
  {
	  
	   axios.get(Serverurl+'ajaxbranch.php?action=getall&bm_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
     
      bm_id:resp.data[0].bm_id,
	  name: resp.data[0].bm_name,
      address: resp.data[0].bm_address,
gstin: resp.data[0].bm_gstin,	  
contactnumber: resp.data[0].bm_contactno,    
    bm_latitude: resp.data[0].bm_latitude, 
bm_longitude: resp.data[0].bm_longitude,    	
    });
	
  }
  
});
	  
  }else{
	 this.setState({  
	  name:'',
	 
	 address:'',
	 contactnumber:'',
	 bm_id:0,
	 gstin:'',
	  bm_latitude: '', 
bm_longitude: '',    
	 
	  }); 
 }
  
    }

onclickbranchclose = (e) => {
	 this.setState({open:false});
}
handleClickOpen = (e) => {
 
  this.setState({open:!this.state.open,  name:'',address:'',contactnumber:'',gstin:'', 
     errormessage:'',erropen:false,
	  });
		this.Branchgetdata();
		


};
myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 
  if(nam==="contactnumber")
  {
	  if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
	  
  }
  }
  else{
  this.setState({[nam]: val});
  }
  

}




handleClose = (e) => {
	
	const regst= /^[0-9]{2}[A-Z]{3}[ABCFGHLJPTF]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
 let name = this.state.name;
 let address = this.state.address;
 let contactnumber = this.state.contactnumber;
  let gstin = this.state.gstin;
  let bm_longitude = this.state.bm_longitude;
  let bm_latitude = this.state.bm_latitude;
if(name==="")
{
	
	this.setState({errormessage:"Please Enter Name",erropen:true});
		
		 return false;
	
	
}

if(contactnumber==="")
{
	
	this.setState({errormessage:"Please Enter Contact Number",erropen:true});
		
		 return false;
	
	
}

if (gstin!=="" && !regst.test(gstin)) {
	 this.setState({errormessage:"Please Enter Valid GST No.",erropen:true});
		 window.scrollTo({        top: 0     })
	return false; 
  }


if(address==="")
{
	
	this.setState({errormessage:"Please Enter Address ",erropen:true});
		
		 return false;
	
	
}
if(bm_latitude==="")
{
	
	this.setState({errormessage:"Please Enter Latitude ",erropen:true});
		
		 return false;
	
	
}
if(bm_longitude==="")
{
	
	this.setState({errormessage:"Please Enter Longitude ",erropen:true});
		
		 return false;
	
	
}



 this.setState({btndisabled:true,submitbtn:"Processing..."})
   var formData = new FormData();
  
  
   if(this.state.bm_id===0)
	  {
		  formData.append('bm_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('bm_id',this.state.bm_id)
		
          }
	  
	  
	  
	  
	 
        formData.append('action','insertorupdate') 
		
		formData.append('bm_name',name)
		formData.append('bm_address',address)
		formData.append('bm_contactno',contactnumber)
		formData.append('bm_gstin',gstin)
		formData.append('bm_longitude',bm_longitude)
		formData.append('bm_latitude',bm_latitude)
		
		formData.append('userid',localStorage.getItem("AYLuserid"))
		  
		axios.post(Serverurl+"ajaxbranch.php", formData, {
        }).then(res => {
    
	
	
	if(res.data === -1)
{ 
	 

		this.setState({errormessage:"Name Already Exist.",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}
	
	
            this.props.updateDonenew();
    
        });
  
	
	this.setState({ open:false,btndisabled:false,
	 submitbtn:"Save", });
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

	


render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.onclickbranchclose} maxWidth="xs" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Manage Branch</DialogTitle>
      <DialogContent>
	  
<div className="formlist">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
						  
		
						  
	<p> <span className="validation">*</span> Name</p>
	
	<p><TextField name="name" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.name}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>	<p> <span className="validation">*</span> Contact Number</p>
	
	<p><TextField name="contactnumber" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.contactnumber}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "2",maxLength:10}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>		
						  
	<p>GSTIN</p>
	
	<p><TextField name="gstin" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.gstin}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "3",maxLength:15}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
			 <p> <span className="validation">*</span> Address</p>
	
	<p><TextField name="address" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   multiline
          rows={4}
	   value={this.state.address}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "4",maxLength:150}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  <p> <span className="validation">*</span> Latitude</p>
	
						  <p><TextField name="bm_latitude" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.bm_latitude}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "6",maxLength:15}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
		<p> <span className="validation">*</span> Longitude</p>
	
						  <p><TextField name="bm_longitude" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.bm_longitude}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "5",maxLength:15}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>
						  
						 	
				
       <div className="actionbtns">
	   <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.onclickbranchclose}>
Cancel
</Button>
</div> 
<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handleClose}>
    {this.state.submitbtn}
</Button>
    </div>        


	
<div className="clear"></div>

 </div>     
	</div>		 
						    </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
 
} 
  